import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import { Target } from "../../utils"
import FooterBase from "../shared/Footer"

const query = graphql`
  query {
    logo: file(relativePath: { eq: "sutea/logo.png" }) {
      childImageSharp {
        gatsbyImageData(width: 100)
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(query)
  const items = {
    name: "すてあ",
    subName: "児童発達支援・放課後等デイサービス",
    target: "sutea" as Target,
    appNum: 1153100597,
    address: "〒360-0012\n埼玉県熊谷市上之１８７７−４",
    tel: "048-598-4075",
    fax: "048-598-4076",
    logo: getImage(data.logo),
  }

  return <FooterBase {...items} />
}

export default Footer
